import React, { useState } from 'react';
import { Routes, Route, Outlet, useNavigate } from 'react-router-dom';
import Home from '../pages/client/Home';
import ProductDetail from '../pages/client/ProductDetail';
import CheckoutPage from '../pages/client/CheckoutPage';
import OrdersPage from '../pages/client/OrdersPage';
import Dashboard from '../pages/admin/Dashboard';
import NotFound from '../pages/NotFound';
import ProtectedRoute from './ProtectedRoute';
import CartDrawer from '../components/store/CartDrawer';
import ProfilePage from '../pages/account/ProfilePage';
import PaymentResultPage from '../pages/client/PaymentResultPage';
import CategoryProductsPage from '../pages/client/CategoryProductsPage';

import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import AuthModal from '../pages/account/AuthModal';

import WarrantyPage from '../pages/client/WarrantyPage';
import ReturnPolicyPage from '../pages/client/ReturnPolicyPage';
import SizeGuidePage from '../pages/client/SizeGuidePage';
import FaqPage from '../pages/client/FaqPage';
import ScrollToTop from '../components/common/ScrollToTop';
// 1. Import QuickViewModal & hook useCart
import QuickViewModal from '../components/store/QuickViewModal';
import { useCart } from '../hooks/useCart';

function ClientLayout() {
    const [isAuthOpen, setIsAuthOpen] = useState(false);
    const [isLoginMode, setIsLoginMode] = useState(true);
    const [isCartOpen, setIsCartOpen] = useState(false);

    // 2. Thêm state quản lý sản phẩm được chọn để xem QuickView
    const [selectedProduct, setSelectedProduct] = useState(null);
    const { addToCart } = useCart();
    const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <ScrollToTop />
      <Header 
        onOpenCart={() => setIsCartOpen(true)}
        setIsAuthOpen={setIsAuthOpen} 
        setIsLoginMode={setIsLoginMode} 
      />
      
      <CartDrawer 
        isOpen={isCartOpen} 
        onClose={() => setIsCartOpen(false)} 
        onOpenCheckout={() => navigate('/checkout')}
        onOpenAuth={() => {
          setIsLoginMode(true);
          setIsAuthOpen(true); // Bật modal đăng nhập
        }}
      />

            <main className="flex-grow">
                <Outlet />
            </main>

            <Footer />

            <AuthModal
                isOpen={isAuthOpen}
                onClose={() => setIsAuthOpen(false)}
                isLoginMode={isLoginMode}
                setIsLoginMode={setIsLoginMode}
            />

            {/* 4. Hiển thị QuickViewModal tại ClientLayout */}
            <QuickViewModal
                product={selectedProduct}
                onClose={() => setSelectedProduct(null)}
                addToCart={addToCart}
            />
        </div>
    );
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<ClientLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/product" element={<ProductDetail />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/orders/:id" element={<OrdersPage />} />
        <Route path="/payment-result" element={<PaymentResultPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/addresses" element={<ProfilePage />} />

        <Route path="/support/bao-hanh" element={<WarrantyPage />} />
        <Route path="/support/doi-tra" element={<ReturnPolicyPage />} />
        <Route path="/support/chon-size" element={<SizeGuidePage />} />
        <Route path="/support/faqs" element={<FaqPage />} />
        <Route path="/category/:slug" element={<CategoryProductsPage />} />
      </Route>
      
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute isAdminRequired={true}>
            <Dashboard />
          </ProtectedRoute>
        } 
      />

            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}